<template>
    <div class="page-location split-view grid grid__split">
        <!-- mobile -->
        <div v-if="isMobile" class="page-location--content split-view--content split-view--content__mobile">
            <!-- loader -->
            <transition name="trs-wave-loader-fade">
                <div class="split-view--loader" v-if="isLoading">
                    <cmp-wave-loader></cmp-wave-loader>
                </div>
            </transition>

            <transition name="trs-placeholder-content-fade">
                <div class="split-view--inner" v-if="!isLoading">
                    <cmp-main-placeholder :is-loading="isLoading" :container="containers.main"></cmp-main-placeholder>
                </div>
            </transition>
        </div>

        <!-- desktop -->
        <div v-if="!isMobile" class="page-location--content split-view--content split-view--content__desktop">
            <div class="split-view--header">
                <div class="grid--container split-view--container">
                    <cmp-main-nav class="split-view--nav" facet="split"></cmp-main-nav>
                </div>
            </div>

            <!-- loader -->
            <transition name="trs-wave-loader-fade">
                <div class="split-view--loader" v-if="isLoading">
                    <cmp-wave-loader></cmp-wave-loader>
                </div>
            </transition>

            <div class="split-view--inner">
                <cmp-main-placeholder :is-loading="isLoading" :container="containers.main"></cmp-main-placeholder>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import routeMixin from 'framework/mixins/route';
    import isMobileMixin from 'framework/mixins/is-mobile';
    import scrollLockHelperMixin from 'framework/mixins/scroll-lock-helper';

    export default {
        mixins: [
            routeMixin,
            isMobileMixin,
            scrollLockHelperMixin,
        ],
        computed: {
            ...mapGetters(['viewport']),
            isPrint() {
                return this.viewport.mq.type === 'print';
            },
        },
        methods: {
            ...mapActions(['setLocationNav']),
        },
        watch: {
            'routeData.location_navigation': {
                handler(nav) {
                    if (!nav) {
                        return;
                    }

                    this.setLocationNav({ nav });
                },
                immediate: true,
            },
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/pages/location/index.vue?5d89c62a